import * as React from 'react';

import DomainsModuleRenderer from 'bundles/front-page/redesign-modules/domains/DomainsModuleRenderer';
import MerchandisingBucketsModuleRenderer from 'bundles/front-page/redesign-modules/merchandising-buckets/MerchandisingBucketsModuleRenderer';
import TestimonialsModuleRedesignRenderer from 'bundles/front-page/redesign-modules/testimonials/TestimonialsModuleRedesignRenderer';

// Page content of LOHP Redesign Q3 2025
const FrontPageContent = () => {
  return (
    <div>
      <MerchandisingBucketsModuleRenderer />
      <DomainsModuleRenderer />
      <TestimonialsModuleRedesignRenderer />
    </div>
  );
};

export default FrontPageContent;
